import _ from 'underscore';
import BaseView from '../../core/baseView';
import { getRules } from '../../validation/validation-controller';

export default BaseView.extend({
    initialize: function () {
        this.bindValidation();
    },

    bindValidation: function () {
        var self = this;
        var model = self.model.toJSON();
        var $fields = this.$el.find('input, select').not('.is-hidden, [type="hidden"]');

        _.each($fields, function (field) {
            var fieldName = field.name.match(/\[.*]/g)[0].slice(1, -1);
            var rules = getRules(fieldName);
            var $field = $(field);

            if ($field.closest('.is-hidden').length === 0) {
                $field.rules('add', self.collectRulesForField(fieldName, !_.isEmpty(rules), model));
            } else {
                $field.rules('remove');
            }

            $field.validate();
        });
    },

    collectRulesForField: function (fieldName, isApplyRequired, model) {
        var rules = {};

        if (isApplyRequired) {
            rules['error.required'] = {
                rule: function () {
                    if (model.creditCardFormVisible === true) {
                        return true;
                    }

                    return false;
                },
                validationType: 'error',
                validationMethod: 'required'
            };
        }

        if (fieldName === 'eps') {
            rules['error.required'] = {
                rule: '#payment_eps:checked',
                validationType: 'error',
                validationMethod: 'required'
            };
        }

        return rules;
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentValidationView.js
 **/